import { useState, useEffect, Fragment } from "react";
import { Card, Col, Row, Table, Button, Form, ListGroup } from "react-bootstrap";
import {ArrowLeftCircle, Trash} from "react-bootstrap-icons";
import Breadcrumb from "app/components/Breadcrumb";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import ContractDetails from "app/views/app/contract/ContractDetail";
import { Formik } from "formik";
import MultiselectTreeCtrl from "../dashboard/userDashboard/MultiselectTreeCtrl";
import {BiSave, BiX} from "react-icons/bi";
import {useLazyAddEditAccessGroupFacilitiesQuery, useLazyGetAccessGroupDetailQuery} from "app/redux/Facility/facilityApi";
import {getDefaultSelectedFromOptions} from "../dashboard/modal/DropDownModal";
import { toast } from "react-toastify";
import Accordion from "react-bootstrap/Accordion";
import UserDetails from "../dashboard/userDashboard/UserDetails";
import { useSelector } from "react-redux";
import { useLazyGetAccessGroupUsersQuery } from "app/redux/Users/Accessusers/accessUsersApi";
import swal from "sweetalert2";
import { MdOutlineLinkOff } from "react-icons/md";
import { color } from "echarts";
import {useLazyDeleteCustomAccessGroupQuery, useLazyRemoveCustomAccessGroupPropertyUnitsQuery,
  useLazyRemoveCustomAccessGroupUserQuery, useLazyAddEditCustomAccessGroupAccessPointsQuery, 
  useLazyGetAMSVendorAccessGroupDetailByIdQuery
} from "app/redux/AMS/amsApi";
import AddDirectUser from "./modal/AddDirectUser";
import AddCustomPropertyUnitsModal from "./modal/AddCustomPropertyUnits";
import { useLazyGetPropertyFloorEntranceQuery } from "app/redux/Building/buildingApi";
import AddEditAccessPoints from "./modal/AddEditAccessPoint";
import AccessPointDetails from "../AccessPoint/AccessPointDetails";
import { Link } from "react-router-dom";

function AccessGroupDetail({ open, eventObject, handleEventDialogSubmit, closeDialog }) {

    const initialState = {
        loginUserName: localStorage.getItem("loginUserName") ?? "",
        loginUserPersonId: localStorage.getItem("loginUserPersonId") ?? "",
        loginUserEmail: localStorage.getItem("loginUserEmail") ?? "",
    };
    const { selectedCompanyId } = useSelector((state) => state.company);
    const [getAccessGroupUsers] = useLazyGetAccessGroupUsersQuery();
    const [userDetailModalState, setuserDetailModalState] = useState({
      userEventObject: {},
      eventDialogOpen: false,
    });
    const [directUserModalState, setDirectUserModalState] = useState({
      directUserDialogValues: {},
      showDirectUserDialog: false,
    });
    const [customPUModalState, setCustomPUModalState] = useState({
      customPUDialogValues: {},
      showCustomPUDialog: false,
    });
    const [accessPointModalState, setAccessPointModalState] = useState({
      accessPointModalDialogValues: {},
      showAccessPointModalDialog: false,
    });
    const [accessPointDetailModalState, setAccessPointDetailModalState] = useState({
        AccessPointObject: {},
        eventAccessPointDetailDialogOpen: false,
    });
    const companyAccessPointList = useSelector((state) => {
            return state.facility.companyAccessPointList;
    });
    const [contractmodalState, setcontractModalState] = useState({contractEventObject: {},contractEventDialogOpen: false});
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [addEditAccessGroupFacilities] = useLazyAddEditAccessGroupFacilitiesQuery();
    const [getAccessGroupDetail] = useLazyGetAccessGroupDetailQuery();
    const [getPropertyFloorEntrance] = useLazyGetPropertyFloorEntranceQuery();
    //const [FacilityData, setFacilityDataState] = useState(eventObject.FacilityData);
    let [accessGroupDetailList, setAccessGroupDetailListState] = useState([]);
    const [directUserlList, setDirectUserlListState] = useState([]);
    const [propertyUnitList, setPropertyUnitListState] = useState([]);
    const [propertyUnitDetails, setPropertyUnitDetails] = useState([]);
    const [deleteCustomAccessGroup] = useLazyDeleteCustomAccessGroupQuery();
    const [removeCustomAccessGroupPropertyUnits] = useLazyRemoveCustomAccessGroupPropertyUnitsQuery();
    const [removeCustomAccessGroupUser] = useLazyRemoveCustomAccessGroupUserQuery();
    const [addEditCustomAccessGroupAccessPoints] = useLazyAddEditCustomAccessGroupAccessPointsQuery();

    const [getAMSVendorAccessGroupDetailById] = useLazyGetAMSVendorAccessGroupDetailByIdQuery();
    let isAccessPointDataSaved = true;
    //const form = useForm({
    //   defaultValues: {
    //     FacilityData: []
    //   }
    // })
    // const FacilityData = form.useStore((state) => state.value.FacilityData);//eventObject.FacilityData;
    const [FacilityData, setFacilityDataState] = useState(eventObject.FacilityData);
    const [selectedOptions, setSelectedOptions] = useState([]);
    console.log('FacilityData --- ', FacilityData);
    const [isALLExpand, setIsALLExpandState] = useState(true);
    //let selectedOptions = getDefaultSelectedFromOptions(FacilityData);
    let isValueUpdate = false;
    let accessUserList = useSelector((state) => {
      return state.accessUser.accessUserList;
    });

    let amssynccompanyAccessGroupList = useSelector((state) => {
      return state.ams.amssynccompanyAccessGroupList;
    });

    let callingScreen = eventObject.CallingScreen;

    useEffect(() => {
      console.log('eventObject.FacilityData - ', eventObject.FacilityData);
        if(!accessUserList || accessUserList.length <= 0){
          getUserList();
        }

        if(eventObject.CallingScreen && eventObject.CallingScreen === 'ACCESSGROUP'){
          //FacilityData = eventObject.FacilityData
          const tempselectedOptions = getDefaultSelectedFromOptions(FacilityData);
          setSelectedOptions(tempselectedOptions);
          var diruser = eventObject.directUsers.map(o => o.vendorCustomerId);
          setDirectUserlListState(diruser);
  
          var pu = eventObject.customPropertyUnits.map(o => o.vendorId);
          setPropertyUnitListState(pu);
          
          getAccessGroupDetailData(eventObject.objectId, eventObject.objectType, diruser, pu, tempselectedOptions);
        }
        else{
          getAMSVendorAccessGroupDetailDataById(localStorage.getItem('CompanyId'), eventObject.objectId, eventObject.amsAccessGroupId, eventObject.objectType )
        }
        
    },[]);


    const getUserList = () => {
      showLoader();
      getAccessGroupUsers({
        companyId: selectedCompanyId,
        type: "GET_ACCESSGROUP",
      }).then((result) => {
        if (result.data.data?.length > 0) {
          accessUserList = result.data.data;
        }
      }, error => {
        hideLoader();
      });
    }

    const getPropertyUnitData = async () => {
      let data = [];
      const data2 = await getPropertyFloorEntrance({
        propertyid: 0,
        type: "FORFACILITY",
      }).then((result) => {
        hideLoader();
        if (result.data.data.PropertyUnitsDetail?.length > 0) {
            let puData = result.data.data.PropertyUnitsDetail
            data = mergePropertyUnitArrayObject(puData);
            return data;
        }
      }, error => {
        hideLoader();
        return data;
      });
      return data2;
    }

    const mergePropertyUnitArrayObject = (rawData) =>
      {
        let mainObj = [];
        if (Array.isArray(rawData)){
          rawData.forEach((item) => {
            let tempObj = {};
            tempObj = item;
            tempObj = {
              ...item,
              value: item.ID,
              ConcatName: item.Name,
              label: item.Name,
              checked: false,
              children: []
            };
            mainObj.push(tempObj);
          });
        }
        setPropertyUnitDetails(mainObj);
        return mainObj;
      }

    const getAccessGroupDetailData = (AccessGroupId, AccessType, directUsers, propertyunits, customAccesPoints) => {
        showLoader();
                
        let obj1 = {};
        obj1.AccessGroupId = AccessType.toLowerCase() !== 'custom' ? AccessGroupId : 0;
        obj1.AccessType = AccessType;
        obj1.PropertyUnitIds = propertyunits;
        obj1.UserIds = directUsers;
        const request = JSON.stringify(obj1);
        getAccessGroupDetail({
          request
          }).then((result) => {
            hideLoader();
           
            if(result.isSuccess){
                console.log('PropertyUnits -- ', result);
                if (result.data && result.data.data) {
                   const data = result.data.data;
                    setAccessGroupDetailListState(data);
                    const autoAccessGroupAccessPoints = data.Facilities;
                    setAccessPoints(autoAccessGroupAccessPoints, customAccesPoints, eventObject.FacilityData, AccessType)
                }
            }
          }, error => {
            hideLoader();
            toast.error(error);
         });
    }

    const setAccessPoints = (accessPoints,customAccesPoints, data, groupType) => {
      if(groupType === 'custom'){
        
        if(customAccesPoints && customAccesPoints.length > 0){
          if(callingScreen !== 'ACCESSGROUP')
          {
            let customFacility = [];
            customAccesPoints.forEach((facilityItem) => {
              const faId = eventObject.FacilityData.filter(a => a.FacilityId === facilityItem.vendorId);
              if(faId && faId.length > 0){
                let tempFacility = {};
                tempFacility.FacilityId = facilityItem.vendorId;
                tempFacility.FacilityName = faId[0].FacilityName;
                tempFacility.amsAccessPointId = faId[0].amsAccessId;
                customFacility.push(tempFacility);
              }
            });
            const OptionsAccessGroup = prepareAccessPointData(data, customFacility);
            eventObject.FacilityData = OptionsAccessGroup;
            setFacilityDataState(eventObject.FacilityData);
            const tempselectedOptions = getDefaultSelectedFromOptions(OptionsAccessGroup);
            setSelectedOptions(tempselectedOptions);
          }
          
        }
        
      }
      else{
        const OptionsAccessGroup = prepareAccessPointData(data, accessPoints);
        eventObject.FacilityData = OptionsAccessGroup;
        setFacilityDataState(eventObject.FacilityData);
        const tempselectedOptions = getDefaultSelectedFromOptions(OptionsAccessGroup);
        setSelectedOptions(tempselectedOptions);
      }
      
    }

  const getAMSVendorAccessGroupDetailDataById = (companyId, vendorAccessGroupId, amsAccessGroupId, groupType) => {
    showLoader();
    let obj = {};
    obj.companyId = companyId;
    obj.vendorAccessGroupId = vendorAccessGroupId;
    obj.amsAccessGroupId = amsAccessGroupId;
    obj.type = groupType;
    const request = JSON.stringify(obj);
    getAMSVendorAccessGroupDetailById({
      request
    }).then((result) => {
      hideLoader();
      if (result.isSuccess) {
        const data = result.data;
        var diruser = data.users.map(o => o.vendorCustomerId);
        setDirectUserlListState(diruser);

        var pu = data.parentAccessGroups.map(o => o.vendorId);
        setPropertyUnitListState(pu);

        const customAccessPoints = data.accessPoints;
        
        getAccessGroupDetailData(eventObject.objectId, eventObject.objectType, diruser, pu, customAccessPoints);
      }
    }, error => {
      hideLoader();
    });
  }

    const updateSelectedItems = (selectedItems) => {
        selectedOptions = selectedItems;
        isAccessPointDataSaved = false;
        setFAcilityChecked(selectedItems);
    }

    const setFAcilityChecked = (selectedItems) => {
      eventObject.FacilityData.forEach((item) => {
        if(selectedItems && selectedItems.length > 0){
          const a = selectedItems.filter(a => a.FacilityId === item.FacilityId);
          if(a && a.length > 0){
            item.checked = true;
          }
          else{
            item.checked = false;
          }
        }
        else{
          item.checked = false;
        }
      });
    }

    const handleFormSubmit  = async () => {
        //setLoading(true);
        if(eventObject.objectType !== 'custom'){
          await UpdateAccessGroupFacilities(selectedOptions);
        }
        else{
          await updateCustomAccessGroupFacilities(selectedOptions);
        }
      };

      const handleDeleteAccessPoint  = async (item) => {
        if(item && item.FacilityId){
          const FacilityId = item.FacilityId;
          if(selectedOptions && selectedOptions.length > 0){
            const newSelectedOption = selectedOptions.filter(a => a.FacilityId !== FacilityId);
            if(eventObject.objectType !== 'custom'){
              await UpdateAccessGroupFacilities(newSelectedOption);
            }
            else{
              await updateCustomAccessGroupFacilities(newSelectedOption,selectedOptions);
            }
            setSelectedOptions(newSelectedOption);
          }

        }
      }

      const updateCustomAccessGroupFacilities = async (selectedFacilities,existingFacilities) => {
        showLoader();
        let objExistingFacilities = [];
        existingFacilities.forEach((item) => {
          let tempObj = {};
          tempObj.vendorFacilityId = item.FacilityId;
          objExistingFacilities.push(tempObj);
        });

        let objNewFacilities = [];
        const newFacilities = selectedFacilities;
        newFacilities.forEach((item) => {
          let tempObj = {};
          tempObj.vendorFacilityId = item.FacilityId;
          objNewFacilities.push(tempObj);
        });

        let obj = {};
        obj.companyId = localStorage.getItem('CompanyId');
        obj.vendorAccessGroupId = eventObject.objectId;
        obj.existingAccessPoints = objExistingFacilities;
        obj.newAccessPoints = objNewFacilities;
        obj.updateBy = localStorage.getItem("loginUserPersonId") ?? "0";
        
        await addEditCustomAccessGroupAccessPoints(obj).then((result) => {
          hideLoader()
          if(result.isSuccess){
            isValueUpdate = true;
            //handlePopupClose();
          }
        }, error => {
          hideLoader();
        });

        hideLoader();
      }
    
      const UpdateAccessGroupFacilities = async (selectedFacilities) => {
        showLoader();
        let itemData = eventObject.itemData;
        let obj = {};
        obj["screenType"] = "Edit";
        obj["Companyid"] = itemData.Companyid;
        obj["PropertyID"] = itemData.PropertyID;
        obj["EntranceID"] = itemData.EntranceID;
        obj["FloorID"] = itemData.FloorID;
        obj["PropertyUnitId"] = itemData.PropertyUnitId;
        obj["updatedBy"] = initialState.loginUserPersonId;
        let Facilities = [];
       
        if (Array.isArray(selectedFacilities)){
          selectedFacilities.forEach((item) => {
            let obj1 = {};
            obj1["FacilityId"] = item.FacilityId;
            obj1["Name"] = item.FacilityName;
            Facilities.push(obj1);
          })
        }
    
        obj["Facilities"] = Facilities;
        console.log('obj -- ', obj);
         await addEditAccessGroupFacilities(obj).then((result) => {
           hideLoader()
         });
    
         hideLoader();
      };

      const handleDeleteUser = async (item) => {
        showLoader();
       
        let obj = {};
        obj["companyId"] = localStorage.getItem('CompanyId');
        obj["vendorAccessGroupId"] = eventObject.objectId;
        obj["vendorCustomerId"] = item.customerId;
        obj["accessGroupType"] = eventObject.objectType;
        let tempData = {};
        let dirUser = accessGroupDetailList.DirectUsers;
        let updateDirUser = dirUser.filter(a => a.customerId !== item.customerId);

        const propertyKeys = Object.keys(accessGroupDetailList);
        propertyKeys.forEach((item) => {
          if(item === 'DirectUsers'){
            tempData['DirectUsers'] = updateDirUser;
          }
          else{
            tempData[item] = accessGroupDetailList[item];
          }
        });

        //console.log('handleDeleteUser -- ', item);
        await removeCustomAccessGroupUser(obj).then((result) => {
          hideLoader()
          if(result.isSuccess){
            setAccessGroupDetailListState(tempData);
            isValueUpdate = true;
          }
        });
    
         hideLoader();
      }

      const handleDeletePropertyUnits = async (item) => {
       console.log(item);
        showLoader();
       
        let obj = {};
        obj["companyId"] = localStorage.getItem('CompanyId');
        obj["vendorAccessGroupId"] = eventObject.objectId;
        obj["vendorPropertyUnitId"] = item.PropertyUnitId;
        let tempData = {};
        let customPropertyUnits = accessGroupDetailList.PropertyUnits;
        let updateCustomPropertyUnits = customPropertyUnits.filter(a => a.PropertyUnitId !== item.PropertyUnitId);

        const propertyKeys = Object.keys(accessGroupDetailList);
        propertyKeys.forEach((item) => {
          if(item === 'PropertyUnits'){
            tempData['PropertyUnits'] = updateCustomPropertyUnits;
          }
          else{
            tempData[item] = accessGroupDetailList[item];
          }
        });

        
        await removeCustomAccessGroupPropertyUnits(obj).then((result) => {
          hideLoader()
          if(result.isSuccess){
            setAccessGroupDetailListState(tempData);
            isValueUpdate = true;
          }
        });
    
         hideLoader();
      }


      

      const handleDeleteCustomGroupEvent = async () => {
        const options = {
          title: "Slett",
          text: "Er du sikker på å slette?",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#fff !important",
          confirmButtonText: "Ja, slett den!",
          cancelButtonText: "Nei"
        };
    
        try {
          const { isConfirmed } = await swal.fire(options);
          if (!isConfirmed)
          {
            return;
          } 
          else{
            showLoader();
       
            let obj = {};
            obj["vendorAccessGroupId"] = eventObject.objectId;
            obj["companyId"] = localStorage.getItem('CompanyId');
            obj["deleteBy"] = localStorage.getItem("loginUserPersonId") ?? "0";
               
            
            await deleteCustomAccessGroup(obj).then((result) => {
              hideLoader()
              if(result.isSuccess){
                toast.success("Group deleted successfully");
                isValueUpdate = true;
                handleEventDialogSubmit('custom');
                closeDialog();
              }
            });
        
             hideLoader();
           
          }
        } catch (error) {}
        
      }

      const closeContractModal = () => {
        setcontractModalState((prev) => ({ ...prev, contractEventDialogOpen: false }));
      }

      const handlePropertyUnitclick = (item) => {
        let eventData = {};
        eventData.ContractId = item.ContractId;
        eventData.PropertyUnitId = item.PropertyUnitId;
        eventData.PropertyUnitName = item.PropertyUnitName;
        setcontractModalState((prevState) => ({
          ...prevState,
          contractEventDialogOpen: true,
          contractEventObject: eventData
        }));
      }

      const handleUserClick = (item) => {
        const existingCustomerId = item.customerId;
        const getUpdatedData = accessUserList.filter(a => a.UserId === existingCustomerId);
        if(getUpdatedData && getUpdatedData[0]){
          item = getUpdatedData[0];
          setuserDetailModalState((prevState) => ({
            ...prevState,
            eventDialogOpen: true,
            userEventObject: { item: item}
          }));
        }

      }

      const handlePopupClose = () => {
        isValueUpdate = true;
        if(isValueUpdate){
          handleEventDialogSubmit('custom');
          closeDialog();
        }
        else{
          closeDialog();
        }
      }

      const closeModal = () => {
        setuserDetailModalState((prev) => ({ ...prev, eventDialogOpen: false }));
      }

      const toggleDirectUserEditorDialog = (arg) => {
        let initialValues = {vendorAccessGroupId: eventObject.objectId, accessGroupType: eventObject.objectType, isParentValueUpdate: isAccessPointDataSaved}
        if (arg && arg.toString()) {
          setDirectUserModalState((prevState) => ({ ...prevState, showDirectUserDialog: true, directUserDialogValues: initialValues }));
        } else {
          setDirectUserModalState((prevState) => ({
            ...prevState,
            directUserDialogValues: initialValues,
            showDirectUserDialog: !directUserModalState.showDirectUserDialog
          }));
        }
      };

      const toggleCustomPUDialog = async (arg) => {
        let InclPropertyUnit = propertyUnitDetails;
        if(InclPropertyUnit.length <= 0){
          InclPropertyUnit = await getPropertyUnitData();
        }
        var existinPropertyUnits = eventObject.customPropertyUnits.map(o => o.vendorId);
        let tempPropertyUnitDetails = InclPropertyUnit;
        if(existinPropertyUnits){
            existinPropertyUnits.forEach((item) => {
              tempPropertyUnitDetails = tempPropertyUnitDetails.filter(a => a.ID !== item);
            });
        }
        let initialValues = {vendorAccessGroupId: eventObject.objectId, accessGroupType: eventObject.objectType, propertyUnitDetails: tempPropertyUnitDetails, isParentValueUpdate: isAccessPointDataSaved}
        if (arg && arg.toString()) {
          setCustomPUModalState((prevState) => ({ ...prevState, showCustomPUDialog: true, 
            customPUDialogValues: initialValues}));
        } else {
          setCustomPUModalState((prevState) => ({
            ...prevState,
            customPUDialogValues: initialValues,
            showCustomPUDialog: !customPUModalState.showCustomPUDialog
          }));
        }
      };

      const toggleAccessPointModalDialog = async (arg) => {
        let itemData = eventObject.itemData;
        let objAccessGroupDetail = {};
        objAccessGroupDetail["Companyid"] = itemData.Companyid;
        objAccessGroupDetail["PropertyID"] = itemData.PropertyID;
        objAccessGroupDetail["EntranceID"] = itemData.EntranceID;
        objAccessGroupDetail["FloorID"] = itemData.FloorID;
        objAccessGroupDetail["PropertyUnitId"] = itemData.PropertyUnitId;

        let initialValues = {vendorAccessGroupId: eventObject.objectId,accessGroupType: eventObject.objectType, FacilityData: eventObject.FacilityData,objAccessGroupDetail: objAccessGroupDetail}
        if (arg && arg.toString()) {
          setAccessPointModalState((prevState) => ({ ...prevState, showAccessPointModalDialog: true, 
            accessPointModalDialogValues: initialValues}));
        } else {
          setAccessPointModalState((prevState) => ({
            ...prevState,
            accessPointModalDialogValues: initialValues,
            showAccessPointModalDialog: !accessPointModalState.showAccessPointModalDialog
          }));
        }
      };

      const handleModalAccessPointSubmit = async (values) => {
        callingScreen = 'RECALL';
        getAMSVendorAccessGroupDetailDataById(localStorage.getItem('CompanyId'), eventObject.objectId, eventObject.amsAccessGroupId, eventObject.objectType )
      }

      const handleDirectUserFormSubmit = async (values) => {
        //await checkAndUpdateAccessPoint(values.isParentValueUpdate);
        getAMSVendorAccessGroupDetailDataById(localStorage.getItem('CompanyId'), eventObject.objectId, eventObject.amsAccessGroupId, eventObject.objectType )
      }

      const handleCustomPUSubmit = async (values) => {
        //await checkAndUpdateAccessPoint(values.isParentValueUpdate);
        getAMSVendorAccessGroupDetailDataById(localStorage.getItem('CompanyId'), eventObject.objectId, eventObject.amsAccessGroupId, eventObject.objectType )
      }

      // const checkAndUpdateAccessPoint = async (isDataSaved) => {
      //   if(!isDataSaved){
      //     if(eventObject.objectType !== 'custom'){
      //       UpdateAccessGroupFacilities(selectedOptions);
      //     }
      //     else{
      //       updateCustomAccessGroupFacilities(selectedOptions);
      //     }
      //   }
      // }

      const {userEventObject,eventDialogOpen} = userDetailModalState;
      const {contractEventObject,contractEventDialogOpen} = contractmodalState;
      const {directUserDialogValues,showDirectUserDialog} = directUserModalState;
      const {customPUDialogValues,showCustomPUDialog} = customPUModalState;
      const {accessPointModalDialogValues,showAccessPointModalDialog} = accessPointModalState;

      //-----

      const handleAccessPointClick = (item) => {
              const companyAccessPointListData = modifyFacilityObject(companyAccessPointList);
              const facilityData = companyAccessPointListData.filter(a => a.FacilityId === item.FacilityId)[0];
      
              // -- PREPARING OPTIONS WITH CHECKED/SELECTED VALUES
              const OptionsPUIncluded = [];
              const OptionsPUExcluded = [];
      
              const selectedIdsPUInc = [];
              const selectedIdsPUExc = [];
      
              if(Array.isArray(facilityData.IncludedPU)){
                  facilityData.IncludedPU.forEach(incItem => {
                  selectedIdsPUInc.push(incItem.PropertyUnitId);
              })
              }
              if(Array.isArray(facilityData.ExcludedPU)){
                  facilityData.ExcludedPU.forEach(excItem => {
                  selectedIdsPUExc.push(excItem.PropertyUnitId);
              })
              }
      
              if(Array.isArray(propertyUnitDetails)){
                  propertyUnitDetails.forEach(puItem => {
                    const itemPuInc = Object.assign({}, puItem);
                    const itemPuExc = Object.assign({}, puItem);
                    itemPuInc.checked = (selectedIdsPUInc.includes(itemPuInc.ID))? true: false;
                    itemPuExc.checked = (selectedIdsPUExc.includes(itemPuExc.ID))? true: false;
                    OptionsPUIncluded.push(itemPuInc);
                    OptionsPUExcluded.push(itemPuExc);
                  })
                }
      
              const OptionsAccessGroup = prepareAccessGroupData(accessGroupDetailList, facilityData.AccessGroup);
      
              setAccessPointDetailModalState((prevState) => ({
              ...prevState,
              eventAccessPointDetailDialogOpen: true,
              AccessPointObject: { type: "",selectedCompanyId: selectedCompanyId, facilityId: facilityData.FacilityId, facilityName: facilityData.FacilityName, item: facilityData, selectedGroup: facilityData.AccessGroup, groupData: accessGroupDetailList, OptionsAccessGroup, OptionsPUIncluded, OptionsPUExcluded,callingScreen: "ACCESSGROUP"}
              }));
              
          }

      //modifyFacilityObject(companyAccessPointList);
      const modifyFacilityObject = (rawData) =>
        {
          let mainObj = [];
          if (Array.isArray(rawData)){
            rawData.forEach((item) => {
              let tempObj = {};
              tempObj = item;
              tempObj = {
                FacilityId: item.FacilityId,
                FacilityName: item.FacilityName,
                value: item.FacilityId ,
                label: item.FacilityName,
                PlacementName: item.PlacementName,
                checked: false,
                children: []
              };
              mainObj.push(tempObj);
            });
          }
          return mainObj;
      }

      const closeAccessPointDetailModal = () => {
        setAccessPointDetailModalState((prev) => ({ ...prev, eventAccessPointDetailDialogOpen: false }));
      }

      const {
        AccessPointObject,
        eventAccessPointDetailDialogOpen,
      } = accessPointDetailModalState;

      //-------
      return(
        <Fragment>
        {!contractEventDialogOpen && !eventDialogOpen && !eventAccessPointDetailDialogOpen &&
        <div>
          
          <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                <Breadcrumb routeSegments={[{ name: "Access users", path: "/" }, { name: "Tilgangsgruppe (" + eventObject.objectName  + ")" }]} />

                <div className="d-flex align-items-center gap-2">
                    <Button className="mb-3" variant="primary" onClick={() => handlePopupClose()} >
                        <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                        Tilbake
                    </Button>

                    {
                      eventObject && eventObject.objectType === 'custom' && 
                      
                      <Button className="mb-3 ml-2" variant="secondary" onClick={() => handleDeleteCustomGroupEvent()} >
                              <Trash className={'me-2'} size={17}></Trash>
                              Delete
                      </Button>
                    }
                </div>
            </div>
          <Row>
            
            <Col md={4}>
              <Card body className="mb-4 o-hidden">
                  {
                    eventObject && eventObject.objectType === 'custom' && 
                    <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                    <span><i className="i-Home1 text-20 me-1" /> <strong>Brukere fra enheter</strong> </span>
                    <div className="d-flex align-items-center gap-2">
                        <span className="cursor-pointer text-primary" onClick={() => toggleCustomPUDialog()}>
                        {'+ Legg til enheter '}
                        </span>
                    </div>
                  </div>
                  }
                  <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                    {
                      eventObject && eventObject.objectType !== 'custom' ?
                      <span><i className="i-Home1 text-20 me-1" /> <strong>Brukere fra enheter</strong> </span> : ''
                    }
                    {/* <div className="d-flex align-items-center gap-2">
                        <span className="cursor-pointer text-primary" onClick={() => setIsALLExpandState(!isALLExpand)}>
                        {isALLExpand ? 'Collapse All' : 'Expand All'}
                        </span>
                    </div>                     */}
                  </div>
                {/* <h4><i className="i-Business-Mens text-20 me-1" />Brukere fra enheter</h4> */}
               
                    {accessGroupDetailList.PropertyUnits && accessGroupDetailList.PropertyUnits.map((puUserItem, puUserIndex) => (
                        <Accordion className="mb-3" defaultActiveKey="actions">
                        <Accordion.Item key={'puUserItem' + puUserIndex} icon={'i-Home-4'} eventKey={isALLExpand ? "actions" : ""}>
                        <Accordion.Header className="w-100">
                            <div className="card-title mb-0 text-primary">
                            {'i-Home-4' ? <i className={`${'i-Home-4'} me-2 text-15`} /> : null}
                            {
                              <span className="cursor-pointer text-primary" onClick={() => handlePropertyUnitclick(puUserItem)}>
                                {puUserItem.PropertyUnitName}&nbsp;&nbsp;&nbsp;
                                            
                              </span>
                            }
                            {
                              eventObject && eventObject.objectType === 'custom' && 
                              <span className="cursor-pointer text-primary" onClick={() => {
                                swal
                                  .fire({
                                    title: "Fjern enheter",
                                    text: "Er du sikker på å fjerne?",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#fff !important",
                                    confirmButtonText: "Ja, fjern den!",
                                    cancelButtonText: "Nei"
                                  })
                                  .then((result) => {
                                    if (result.value) {
                                      handleDeletePropertyUnits(puUserItem);
                                    } 
                                  });
                              }}>
                                Fjern
                              </span>
                              
                            }
                            
                            </div>
                        </Accordion.Header>

                        <Accordion.Body>
                            {puUserItem.Users && puUserItem.Users.map((userItem, userIndex) => (
                                <>
                                    {userItem.firstName !== "" &&
                                    <ListGroup.Item
                                    action
                                    to="#"
                                    onClick={() => handleUserClick(userItem)}
                                    className="d-flex align-items-center gap-1">
                                    <i className="i-Doctor" />
                                    {userItem.firstName} 
                                  </ListGroup.Item>
                                      }
                                {/* <span className="cursor-pointer text-primary" onClick={() => handleUserClick(userItem)}>
                                    {userItem.firstName} 
                                </span> */}
                                
                                </>
                            ))}
                        
                        {/* <Table bordered className="table table-bordered tbl-custom">
                            <tbody>
                            {puUserItem.Users && puUserItem.Users.map((userItem, userIndex) => (
                                <>
                                {
                                    userItem.firstName !== "" &&
                                    <tr key={'userItem' + userIndex}>
                                        <td>

                                        <span className="cursor-pointer text-primary" onClick={() => handleUserClick(userItem)}>
                                            {userItem.firstName} 
                                        </span>
                                            
                                        </td>
                                    </tr>
                                }
                                </>
                            ))}
                            </tbody>
                        </Table> */}
                        </Accordion.Body>
                        </Accordion.Item>
                        </Accordion>
                    ))}
              </Card>
            </Col>
            <Col md={4}>
              <Card body className="mb-4 o-hidden">
                  <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                  <span><i className="i-Business-Mens text-20 me-1" /> <strong>Direkte brukere</strong> </span>
                    <div className="d-flex align-items-center gap-2">
                        <span className="cursor-pointer text-primary" onClick={(e) => toggleDirectUserEditorDialog(true, e)}>
                        {'+ Legg til bruker'}
                        </span>
                    </div>
                  </div>
                  
                  <Table bordered
                          className="table table-bordered tbl-custom"
                          >
                          <tbody>
                          {accessGroupDetailList.DirectUsers && accessGroupDetailList.DirectUsers.map((duItem, duIndex) => (
                                  <tr key={'directuser' + duIndex}>
                                      <td>
                                      <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                                          <span className="cursor-pointer text-primary" onClick={() => handleUserClick(duItem)}>
                                              {duItem.firstName}
                                          </span>
                                          <div className="d-flex align-items-center gap-2">
                                          <span className="cursor-pointer text-primary" onClick={() => {
                                                  swal
                                                    .fire({
                                                      title: "Fjern bruker",
                                                      text: "Er du sikker på å fjerne?",
                                                      type: "question",
                                                      showCancelButton: true,
                                                      confirmButtonColor: "#3085d6",
                                                      cancelButtonColor: "#fff !important",
                                                      confirmButtonText: "Ja, fjern den!",
                                                      cancelButtonText: "Nei"
                                                    })
                                                    .then((result) => {
                                                      if (result.value) {
                                                        handleDeleteUser(duItem);
                                                      } 
                                                    });
                                                }}>
                                              Fjern
                                          </span>
                                          {/* <span className="cursor-pointer text-primary" >
                                              <MdOutlineLinkOff
                                                style={{color:"grey"}}
                                                size={18}
                                                onClick={() => {
                                                  swal
                                                    .fire({
                                                      title: "Fjern bruker",
                                                      text: "Er du sikker på å fjerne?",
                                                      type: "question",
                                                      showCancelButton: true,
                                                      confirmButtonColor: "#3085d6",
                                                      cancelButtonColor: "#fff !important",
                                                      confirmButtonText: "Ja, fjern den!",
                                                      cancelButtonText: "Nei"
                                                    })
                                                    .then((result) => {
                                                      if (result.value) {
                                                        handleDeleteUser(duItem);
                                                      } 
                                                    });
                                                }}
                                              />
                                                        
                                          </span> */}
                                          
                                          </div>
                                      </div>
                                     
                                      </td>
                                  </tr>
                          ))}
                          </tbody>
                      </Table>
                </Card>
            </Col>
            <Col md={4}>
              <Card body className="mb-4 o-hidden">
                  <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                  {/* <h4>  */}
                    <Link to="/userDashboard/accesspoint">
                      <i className="i-Lock-2" style={{ whiteSpace: "nowrap" }}></i>{" "}
                      <strong>Aksesspunkt</strong>
                    </Link>
                     {/* </h4> */}
                    <div className="d-flex align-items-center gap-2">
                        <span className="cursor-pointer text-primary" onClick={(e) => toggleAccessPointModalDialog(true)}>
                        {'+ Legg til/redigering'}
                        </span>
                    </div>
                  </div>
                  <Table bordered className="table table-bordered tbl-custom">
                          <tbody>
                          {selectedOptions && selectedOptions.map((accessItem, accessIndex) => (
                                  <tr key={'accessPoint' + accessIndex}>
                                      <td>
                                      <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                                          {/* onClick={() => handlePropertyUnitclick(duItem)} */}
                                          <span className="cursor-pointer text-primary" onClick={() => handleAccessPointClick(accessItem)}>
                                            {accessItem.FacilityName}
                                          </span>
                                          <div className="d-flex align-items-center gap-2">
                                          <span className="cursor-pointer text-primary" onClick={() => {
                                                  swal
                                                    .fire({
                                                      title: "Fjern",
                                                      text: "Er du sikker på å fjerne?",
                                                      type: "question",
                                                      showCancelButton: true,
                                                      confirmButtonColor: "#3085d6",
                                                      cancelButtonColor: "#fff !important",
                                                      confirmButtonText: "Ja, fjern den!",
                                                      cancelButtonText: "Nei"
                                                    })
                                                    .then((result) => {
                                                      if (result.value) {
                                                        handleDeleteAccessPoint(accessItem);
                                                      } 
                                                    });
                                                }}>
                                              Fjern
                                          </span>
                                          </div>
                                      </div>
                                     
                                      </td>
                                  </tr>
                          ))}
                          </tbody>
                      </Table>
                </Card>
            </Col>
            
          </Row>
        </div>
        
        }
        {eventDialogOpen &&
          <UserDetails open={eventDialogOpen} handleClose={closeModal} eventObject= {userEventObject} />
        }
        {contractEventDialogOpen &&
           <ContractDetails open={contractEventDialogOpen} handleContractClose={closeContractModal} 
           eventObject= {contractEventObject} />
        }
        {eventAccessPointDetailDialogOpen &&
            <AccessPointDetails
                open={eventAccessPointDetailDialogOpen}
                eventObject={AccessPointObject}
                closeDialog={closeAccessPointDetailModal}
            />
        }

         
          <AddDirectUser
            show={showDirectUserDialog}
            initialValues={directUserDialogValues}
            handleDirectUserFormSubmit={handleDirectUserFormSubmit}
            toggleDirectUserEditorDialog={toggleDirectUserEditorDialog}
          />

          <AddCustomPropertyUnitsModal
            open={showCustomPUDialog}
            eventObject={customPUDialogValues}
            handleSubmit={handleCustomPUSubmit}
            closeDialog={toggleCustomPUDialog}
          />

          <AddEditAccessPoints
            open={showAccessPointModalDialog}
            eventObject={accessPointModalDialogValues}
            handleSubmit={handleModalAccessPointSubmit}
            closeDialog={toggleAccessPointModalDialog}
          />
       
      {loader}

        </Fragment>
    );

}

export default AccessGroupDetail;

export const prepareAccessPointData = (options, selectedItems) => {
  //console.log('Options', options);
  //console.log('selectedItems', selectedItems);

  const selFacilityIds = [];
  const facilityOptions = [];
    if(Array.isArray(selectedItems)){
      selectedItems.forEach(item => {
        selFacilityIds.push(item.FacilityId);
      })
    }

    if(Array.isArray(options)){
      options.forEach(item => {
        const optionItem = Object.assign({}, item);
        optionItem.checked = selFacilityIds.includes(item.FacilityId)? true : false;
        facilityOptions.push(optionItem);
      })
    }
  return facilityOptions;
};

export const refineOption = (data) => {
  if(Array.isArray(data) && data.length){
    data.forEach(item => {
      item.checked = false;
      if(item.checked == null || item.checked == false){
        delete item.checked;
      }
      if(Array.isArray(item.children)){
        item.children = refineOption(item.children);
      }
    })
  }
  return data;
};

export const prepareAccessGroupData = (options: any, selectedItems: any) => {
    // console.log('Options', options);
    // console.log('selectedItems', selectedItems);
  
    let tempdata = JSON.parse(JSON.stringify(options));
  
    if(tempdata && Array.isArray(tempdata) && tempdata.length > 0){
      // console.log('USEEFFECT ---------------------------------- ',);
      // Set already checked to false
      tempdata.forEach((item) => {
        if(item.checked === true){
          item.checked =  false;
        }
        let entrance = item.children;
        if(entrance && Array.isArray(entrance) && entrance.length > 0){
          entrance.forEach((entraceitem) => {
            if(entraceitem.checked === true){
              entraceitem.checked =  false;
            }
            let floor = entraceitem.children;
            if(floor && Array.isArray(floor) && floor.length > 0){
              floor.forEach((floorItem) => {
                if(floorItem.checked === true){
                  floorItem.checked =  false;
                }
              });
            }
          });
        }
      });
  
      // let
  
      //Select preselect data
      if(selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0){
        tempdata.forEach((item) => {
          let ConcatID = item.ConcatID;
          if(item.checked === true){
            item.checked =  false;
          }
          var check = selectedItems.filter(a => a.ConcatID === ConcatID && a.AccessType === 'Direct');
          if(check && check.length > 0){
            item.checked = true;
          }
          let entrance = item.children;
          if(entrance && Array.isArray(entrance) && entrance.length > 0){
            entrance.forEach((entraceitem) => {
              var entranceCheck = selectedItems.filter(a => a.ConcatID === entraceitem.ConcatID&& a.AccessType === 'Direct');
              if(entranceCheck && entranceCheck.length > 0){
                entraceitem.checked = true;
              }
              let floor = entraceitem.children;
              if(floor && Array.isArray(floor) && floor.length > 0){
                floor.forEach((floorItem) => {
                  var floorCheck = selectedItems.filter(a => a.ConcatID === floorItem.ConcatID&& a.AccessType === 'Direct');
                  if(floorCheck && floorCheck.length > 0){
                    floorItem.checked = true;
                  }
                });
                entraceitem.children = floor;
              }
            });
            item.children = entrance;
          }
        });
      }
    }
  
  
    return refineOption(tempdata);
};
  